import { AppSignature } from "src/app/models/app-signature";
import { Board, GradeModel } from "src/app/models/master.model";
import { InstituteGradeSubjectModel } from "../../subject/models/subject-model";
import { StaffModel } from "../../auth";
import { InstituteAcademicYear, InstituteGradeDivision, InstituteGradeDivisionDTO, InstituteGradeDivisionTeacherDTO } from "../../institute-academic-year/models/institute-academic-year";
import { FileTransferModel } from "src/app/models/file-transfer";

export class InstituteTimeTableTemplate extends AppSignature {
    name: string = '';
    isActive: boolean = false;
    direction: string = '';
    days: string = '';
    parentInstituteID: string;
}

export class InstituteTimeTableTemplateHeader extends AppSignature {
    name: string;
    type: string;
    timeFrom: string;
    timeTo: string;
    sortOrder: number;
    parentInstituteTimeTableTemplateID: string;
}

export class InstituteTimeTableTemplateDTO {
    inUse: boolean = false;
    instituteTimeTableTemplate: InstituteTimeTableTemplate = new InstituteTimeTableTemplate();
    instituteTimeTableTemplateHeaders: Array<InstituteTimeTableTemplateHeader> = new Array<InstituteTimeTableTemplateHeader>();
}

export class InstituteClassTimeTable extends AppSignature {
    parentClassTeacherID: string = '';
    parentGradeID: string = '';
    parentInstituteID: string;
    parentInstituteGradeDivisionID: string = '';
    parentInstituteTimeTableTemplateID: string = '';
}
export class InstituteClassTimeTableComponent extends AppSignature {
    parentInstituteSubjectID: string = '';
    parentStaffID: string = '';
    weekday: string;
    parentInstituteClassTimeTableID: string;
    parentInstituteTimeTableTemplateHeaderID: string;
    itemNumber: number;
}

export class InstituteClassTimeTableDTO {
    instituteClassTimeTable: InstituteClassTimeTable = new InstituteClassTimeTable();
    instituteClassTimeTableComponents: Array<InstituteClassTimeTableComponent> = [];
    instituteClassTimeTableComponentDTOs: Array<InstituteClassTimeTableComponentDTO> = [];
    classTeacher: StaffModel;
    grade: GradeModel;
    gradeDivision: InstituteGradeDivision;
    academicYear: InstituteAcademicYear;
    template: InstituteTimeTableTemplateDTO;
    file: FileTransferModel;
}

export class InstituteClassTimeTableComponentDTO {
    instituteClassTimeTableComponent: InstituteClassTimeTableComponent;
    subjectTeacher: StaffModel;
    subject: InstituteGradeSubjectModel;
}

export class TimeTableGradeData {
    board: Board;
    grades: Array<GradeData> = new Array<GradeData>();
}

export class GradeData {
    grade: GradeModel;
    academicYear: InstituteAcademicYear;
    gradeDivisions: Array<InstituteGradeDivisionTeacherDTO> = new Array<InstituteGradeDivisionTeacherDTO>();
    subjectModuleTeachers: Array<SubjectModuleTeachers> = new Array<SubjectModuleTeachers>();
}

export class SubjectModuleTeachers {
    subject: InstituteGradeSubjectModel;
    stubjectTeachers: Array<StaffModel> = new Array<StaffModel>();
}

export class SubjectModuleTeacherModel {
    subject: InstituteGradeSubjectModel;
    stubjectTeacher: StaffModel;
}
export class GradeDivisionModel {
    grade: GradeModel;
    division: InstituteGradeDivision;
}

export class GradeDivisionAcademicYearDTO {
    grade: GradeModel;
    instituteGradeDivision: InstituteGradeDivision;
    academicYear: InstituteAcademicYear;
}

export class GradeDivisionSubjectAcademicYearDTO extends GradeDivisionAcademicYearDTO {
    subject: InstituteGradeSubjectModel;
    board: Board = new Board();
}